import './App.css';
import './index.css';
import AppRouter from './router/AppRouter';
import CombinedProvider from './context/CombinedProvider';
import useViewportHeight from './hooks/useViewportHeight';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    document.getElementById('initial-loader')?.remove();
    window.NativeBridge?.onLoadComplete?.();
  }, []);

  /**
   * Required to calculate vh unit and set it as the height of the document
   * Without this, there's an empty space when keyboard is open on ios spaces
   * causing the user to overscroll.
   *
   * Lives in a hook so the docked search box can freeze it while the keyboard
   * animates — see useViewportHeightFreeze.
   */
  useViewportHeight();

  return (
    <CombinedProvider>
      <AppRouter />
    </CombinedProvider>
  );
}

export default App;
